
import mixpanel from 'mixpanel-browser';
mixpanel.init('c26c504ddb7d07502e22eb6717f0c0f8');

// let env_check = process.env.NODE_ENV === 'production';

let env_check = true;

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;